import { mapMutations } from 'vuex'
import { AppSettingCacheMixin } from './AppSettingCacheMixin'

export const OpenSlotDefaultsSettingMixin = {
  mixins: [AppSettingCacheMixin],
  computed: {
    settingKey () {
      return 'OpenSlotDefaults'
    },
    defaultSettingObject () {
      return {
        hideResourceName: false,
        hideDuration: false,
        extendBeyondSlotDuration: false
      }
    },
    openSlotDefaultsHideResourceName () {
      return this.settingObject?.hideResourceName || false
    },
    openSlotDefaultsHideDuration () {
      return this.settingObject?.hideDuration || false
    },
    openSlotDefaultsExtendBeyondSlotDuration () {
      return this.settingObject?.extendBeyondSlotDuration || false
    }
  },
  watch: {
    openSlotDefaultsExtendBeyondSlotDuration (value) {
      this.setExtendBeyondSlotDuration(value)
    }
  },
  methods: {
    ...mapMutations('BookingUpload', [
      'setExtendBeyondSlotDuration'
    ])
  }
}
